import script from "./complete-the-look.vue?vue&type=script&setup=true&lang=js"
export * from "./complete-the-look.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__